import {Component, OnInit} from '@angular/core';
import {User} from "../models/user";
import {AuthenticationService} from "../services/authentication.service";
import {OrganizationService} from "../services/organization.service";
import {Organization} from "../models/organization";
import {Router} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";
import {AdminSidebarComponent} from "../admin-sidebar/admin-sidebar.component";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-admin-organization-manage',
  templateUrl: './admin-organization-manage.component.html',
  styleUrls: ['./admin-organization-manage.component.css'],
  imports: [
    NgIf,
    AdminSidebarComponent,
    FormsModule,
    NgForOf
  ],
  standalone: true
})
export class AdminOrganizationManageComponent implements OnInit {
  user!: User;
  organizations!: Organization[];
  searchTerm = "";

  constructor(
    public authService: AuthenticationService,
    public orgService: OrganizationService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();

    await this.orgService.getOrganizations(0).then(data => {
      this.organizations = data;
    });
  }

  /**
   * Filters the organizations based on the text filled into the input field
   *
   * @param organizations
   */
  nameFilter(organizations: Organization[]) {
    if (this.searchTerm != undefined && this.organizations != undefined) {
      return organizations.filter(org =>
        org.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
        org.email.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
        org.contactName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
      );
    } else {
      return organizations;
    }
  }

  navigateToOrgProfile(orgID: string) {
    this.router.navigate(['/admin/beheer-organisaties/' + orgID]);
  }
}
